import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function FlightUp(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_1201_111)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M13.914.881C13.424.331 12.774 0 12 0c-.775 0-1.424.332-1.914.881-.462.518-.77 1.21-.988 1.968-.391 1.363-.562 3.212-.593 5.401L.718 10.54A1 1 0 000 11.5V14a1 1 0 001 1h7.605l.355 3.199-1.74 2.176a1 1 0 00-.114 1.072l1 2a1 1 0 001.21.502L12 23.054l2.684.895a1 1 0 001.21-.502l1-2a1 1 0 00-.113-1.072L15.04 18.2 15.395 15H23a1 1 0 001-1v-2.5a1 1 0 00-.718-.96l-7.787-2.29c-.03-2.189-.202-4.038-.593-5.4-.218-.759-.526-1.452-.988-1.969zm-.934 2.52c.354 1.234.52 3.116.52 5.599a1 1 0 00.718.96L22 12.247V13h-7.5a1 1 0 00-.994.89l-.5 4.5a1 1 0 00.213.735l1.6 2-.326.652-2.177-.726a1 1 0 00-.632 0l-2.177.726-.326-.652 1.6-2a1 1 0 00.213-.735l-.5-4.5A1 1 0 009.5 13H2v-.752L9.782 9.96A1 1 0 0010.5 9c0-2.483.166-4.365.52-5.599.177-.617.379-.987.558-1.188.151-.17.275-.213.422-.213.147 0 .27.043.422.213.18.201.38.571.558 1.188z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_1201_111"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default FlightUp;